const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

export const sendWhatsApp = async (toOrOpts, message) => {
  try {
    const payload = typeof toOrOpts === 'object' && toOrOpts !== null
      ? { to: toOrOpts.to, userId: toOrOpts.userId, message: toOrOpts.message }
      : { to: toOrOpts, message };
    const token = localStorage.getItem('developmentexpress_token');
    const res = await fetch(`${API_BASE_URL}/api/notifications/whatsapp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token || ''}`,
      },
      body: JSON.stringify(payload),
    });
    return await res.json();
  } catch (err) {
    console.error('WhatsApp error:', err);
  }
};

export const sendBookingNotifications = async ({ booking, client, machine, operator, owner }) => {
  const ref = booking.id;
  const machineName = machine?.name || 'N/A';
  const location = booking.location || 'N/A';
  const type = booking.type || 'N/A';
  const advance = booking.advance?.toLocaleString('en-IN') || '0';
  const total = booking.total?.toLocaleString('en-IN') || '0';
  const date = new Date().toLocaleDateString('en-IN', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
  const time = new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });

  const notifications = [
    // Client
    client?.userId && {
      userId: client.userId,
      message: `*Development Express - Booking Confirmed!*\n\nRef: ${ref}\nDate: ${date} ${time}\nMachine: ${machineName}\nType: ${type}\nLocation: ${location}\nAdvance Paid: ₹${advance}\nTotal: ₹${total}\n\nMachine will be dispatched after owner approval.\n\nDevelopment Express\n+91-8408000084`
    },
    // Admin
    {
      to: '+918408000084',
      message: `*Development Express - New Booking Alert!*\n\nRef: ${ref}\nDate: ${date} ${time}\nClient: ${client?.name || 'N/A'}\nMachine: ${machineName}\nType: ${type}\nLocation: ${location}\nAdvance: ₹${advance}\nTotal: ₹${total}\n\nDevelopment Express`
    },
    // Owner
    owner?.userId && {
      userId: owner.userId,
      message: `*Development Express - Machine Booking Request!*\n\nRef: ${ref}\nDate: ${date} ${time}\nMachine: ${machineName}\nClient: ${client?.name || 'N/A'}\nLocation: ${location}\nType: ${type}\nTotal: ₹${total}\n\nPlease approve in Owner Dashboard.\n\nDevelopment Express\n+91-8408000084`
    },
    // Operator
    operator?.userId && {
      userId: operator.userId,
      message: `*Development Express - New Assignment!*\n\nRef: ${ref}\nDate: ${date} ${time}\nMachine: ${machineName}\nClient: ${client?.name || 'N/A'}\nLocation: ${location}\nType: ${type}\n\nPlease check Operator Dashboard.\n\nDevelopment Express\n+91-8408000084`
    },
  ].filter(Boolean);

  // Send all notifications
  for (const n of notifications) {
    await sendWhatsApp(n);
  }
};

export const sendWalletNotification = async ({ userId, phone, name, type, amount, balance, ref }) => {
  const message = type === 'credit'
    ? `*Development Express - Wallet Credit!*\n\nDear ${name},\n₹${amount?.toLocaleString('en-IN')} credited to your wallet.\nRef: ${ref}\nNew Balance: ₹${balance?.toLocaleString('en-IN')}\n\nDevelopment Express\n+91-8408000084`
    : `*Development Express - Wallet Debit!*\n\nDear ${name},\n₹${amount?.toLocaleString('en-IN')} deducted from your wallet.\nRef: ${ref}\nNew Balance: ₹${balance?.toLocaleString('en-IN')}\n\nDevelopment Express\n+91-8408000084`;
  if (userId) return sendWhatsApp({ userId, message });
  if (phone) return sendWhatsApp(phone.startsWith('+') ? phone : '+91' + phone, message);
};

export const sendBookingWhatsApp = (clientPhone, bookingDetails) => {
  const message = `*Development Express Booking Confirmed!*\n\nMachine: ${bookingDetails.machine}\nType: ${bookingDetails.type}\nAdvance: ₹${bookingDetails.advance}\nRef: ${bookingDetails.id}\n\nDevelopment Express - +91-8408000084`;
  return sendWhatsApp(clientPhone, message);
};

export const sendIssueWhatsApp = (adminPhone, issueDetails) => {
  const message = `*Development Express Issue Alert!*\n\nMachine: ${issueDetails.machine}\nIssue: ${issueDetails.type}\nDescription: ${issueDetails.description}\nOperator: ${issueDetails.operator}\n\nPlease take immediate action!`;
  return sendWhatsApp(adminPhone, message);
};
